// =============================
// Imports
// =============================

import { Component } from 'react';

import MetaEntities from '../entities';

import config from './config';

// =============================
// Component
// =============================

export default class MetaBriefs extends Component {
  render() {
    const { ...restProps } = this.props;

    return (
      <MetaEntities
        {...restProps}
        entityConfig={config}
        initProp="title"
      />
    );
  }
}
